<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_v"><span class="small">CONTENTS</span></a></p><a id="page_v">
</a><p class="TocSb1" id="for"><a id="page_v"></a><a href="#/xhtml/foreword#for"><i>Foreword</i> by Christine Pohl</a></p>
<p class="Toc1a" id="ack"><a href="#/xhtml/acknowledgements#ack">Acknowledgments</a></p>
<p class="Toc1a" id="int"><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="Toc" id="ch-001"><a href="#/xhtml/chapter001#ch001">1.<span class="space1">Founding Community</span></a></p>
<p class="Toc1"><a href="#/xhtml/chapter001#ch001">Jesus and His Friends</a></p>
<p class="Toc" id="ch-002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">2.<span class="space1">Cultivating Christian Friendship</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">Conversations through History</span></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space1">“God with Us”</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">Friendship and Remaining</span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space1">Exile</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">Friendship and Family</span></p>
<p class="Toc" id="ch-005"><a id="page_vi"></a><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space1">Testimony</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">Friendship and Struggle</span></p>
<p class="Toc" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space1">Celebration</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">Friendship and Joy</span></p>
<p class="Toc" id="ch-007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7.<span class="space1">Christian Friendship Today</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">Mustard Seeds of Hope</span></p>
<p class="Toc1b" id="app"><span href="#/xhtml/appendix#app" title="Link target outside of Sample">Appendix</span></p>
<p class="Toc1a" id="note"><span href="#/xhtml/notes#note" title="Link target outside of Sample">Notes</span></p>
<p class="Toc1a" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Index of Names and Subjects</span></p>
<p class="Toc1a" id="idx-002"><span href="#/xhtml/index002#idx002" title="Link target outside of Sample">Index of Scripture</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?85b8494a